module.exports = __webpack_public_path__ + "media/images/u2-4efd31c67896cf57225bfa22b258c92e.png";